// extracted by mini-css-extract-plugin
export var headerContainer = "styles-module--headerContainer--eRjAe";
export var sticky = "styles-module--sticky--zxWg8";
export var darkMode = "styles-module--darkMode--3GBx1";
export var logo = "styles-module--logo--ykcJf";
export var infoDarkMode = "styles-module--infoDarkMode--f51Kz";
export var header = "styles-module--header--s+5lD";
export var darkSmallCaps = "styles-module--darkSmallCaps--YeyU+";
export var infoContainer = "styles-module--infoContainer--JDxeJ";